import { get } from 'lodash'
import { Container } from 'unstated'
import clientData from 'utils/client-data'

class VisaPlusProfileState extends Container {
  state = {
    evaluateProfileDetails: get(
      clientData,
      'visaPlusProfileEvaluationDetails',
      {},
    ),
    userCIPVerified: false, // NOTE: To be populated after product-provisioning API integration. false is a default state.
  }
}

export default VisaPlusProfileState
